import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Scan, Sparkles, Phone } from "lucide-react";
import { api } from "../lib/api";
import { PageHero } from "./About";
import { ScrollReveal } from "../components/ScrollReveal";
import { ServiceIcon } from "../components/ServiceIcon";

export default function Diagnostics() {
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });
  const diagnostic = services.filter((s) => s.category === "diagnostic");

  return (
    <div>
      <PageHero eyebrow="X-Ray & Diagnostics" title="Digital X-Ray Service — Coming Soon" subtitle="The clinic's X-Ray service is not yet operational. Contact us for launch updates." />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <div className="relative rounded-[2rem] overflow-hidden shadow-xl border-4 border-white bg-[#0B1B33] h-[420px]">
              <div className="absolute inset-0 grid-pattern opacity-30" />
              <div className="absolute -top-16 -right-10 w-64 h-64 rounded-full bg-[#00D2FF]/20 blur-3xl" />
              <div className="absolute -bottom-16 -left-10 w-64 h-64 rounded-full bg-[#1A75BC]/30 blur-3xl" />
              <div className="xray-beam" />
              <div className="relative h-full flex flex-col items-center justify-center gap-5">
                <Scan size={92} strokeWidth={1} className="text-[#00D2FF]/70" />
                <div className="text-3d text-3xl sm:text-[2.75rem] leading-none font-extrabold tracking-tight -rotate-6 select-none" data-testid="xray-coming-soon">Coming Soon</div>
                <div className="text-white/60 font-mono text-[11px] tracking-widest">DIGITAL RADIOGRAPHY</div>
              </div>
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between text-white font-mono text-xs">
                <span className="bg-black/40 backdrop-blur px-3 py-1.5 rounded-full flex items-center gap-2"><span className="w-2 h-2 bg-[#00D2FF] rounded-full animate-pulse" /> SCANNING</span>
                <span className="bg-black/40 backdrop-blur px-3 py-1.5 rounded-full">HD · Low Dose</span>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.12}>
            <p className="eyebrow mb-3 flex items-center gap-2"><Sparkles size={14} /> Service Update</p>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0F1E36]">X-Ray service is coming soon</h2>
            <p className="mt-4 text-[#627D98] leading-relaxed">Revive Family Clinic is preparing to introduce X-Ray services. Until the service is launched, the clinic does not accept X-Ray appointments.</p>
            <p className="mt-4 text-[#627D98] leading-relaxed">For current medical consultations or an update on the X-Ray launch, call the clinic during opening hours.</p>
            <a href="tel:+918608323094" className="inline-flex items-center gap-2 mt-8 gradient-bg btn-glow text-white font-bold px-6 py-3 rounded-full" data-testid="diagnostics-book-btn"><Phone size={18} /> Call 8608323094</a>
          </ScrollReveal>
        </div>
      </section>

      {false && diagnostic.length > 0 && (
        <section className="py-16 lg:py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <ScrollReveal className="mb-12">
              <p className="eyebrow mb-3">Diagnostic Tests</p>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0F1E36]">Diagnostic Services We Offer</h2>
            </ScrollReveal>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {diagnostic.map((s, i) => (
                <ScrollReveal key={s.id} delay={i * 0.06}>
                  <div className="card-lift bg-white rounded-2xl border border-slate-100 p-7 h-full">
                    <div className="w-14 h-14 rounded-2xl gradient-bg flex items-center justify-center text-white mb-5"><ServiceIcon name={s.icon} size={26} /></div>
                    <h3 className="text-xl font-bold text-[#0F1E36] mb-2">{s.title}</h3>
                    <p className="text-sm text-[#627D98] leading-relaxed">{s.description}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
